export enum DisplayBoardStyle {
  AllInOne = 1,
  PhaseAtTime = 2,
  WorkflowAtTime = 3,
}
